
import { defineComponent } from 'vue'

export default defineComponent({
    name: "widget-18",
    props: {
        widgetClasses: String,
        icon: String,
        title: String,
        subTitle: String,
        amount: Number,
        itemsList: null,
    }
})
